module.exports = __webpack_public_path__ + "static/media/tabs-battles-disabled.54866504.png";